import { Component, Input } from '@angular/core';
import { fadeInOutAnimation } from '@app/core/animations';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'rk-setting-container',
  templateUrl: './setting-container.component.html',
  styleUrls: ['./setting-container.component.scss'],
  animations: [fadeInOutAnimation],
  standalone: false,
})
export class SettingContainerComponent {
  @Input()
  name?: string;
  @Input()
  tag?: string;
  @Input()
  icon?: IconProp;
  @Input()
  compactLayout?: boolean;
  @Input()
  isOpen = true;

  toggleContent(): void {
    this.isOpen = !this.isOpen;
  }
}
